import { useEffect, useMemo, useRef, useState } from "react";
import { Box, CircularProgress } from "@mui/material";
import { ModalContainer, ShimmerEffect, SkeletonCircle } from "./styled";
import { Flex, Radio, Alert, Button, Modal, Select, Spin, Input, Steps } from "antd";
import { toast } from "react-toastify";
import { LoadingOutlined } from "@ant-design/icons";
import styles from "./SegmentedRadioGroup.module.css";

import Processos from "../Processo";
import GroupOrdemServico from "./Group/GroupOrdemServico";
import GroupContato from "./Group/GroupContato";
import GroupEmpresa from "./Group/GroupEmpresa";
import GroupAcessos from "./Group/GroupAcessos";
import GroupFaturamento from "./Group/GroupFaturamento";
import GroupDocumentos from "./Group/GroupDocumentos";
import GroupHistorico from "./Group/GroupHistorico";
import GroupQuadroSocioAdministrativo from "./Group/GroupQuadroSocioAdministrativo";
import GroupInicio from "./Group/GroupInicio";

import GerarPix from "./Modais/GerarPix";
import AtualizarCliente from "./AtualizarCliente";

import CadastrarCliente from "./Modais/CadastrarCliente";
import AtribuirAnalista from "./Modais/AtribuirAnalista";
import ImportDocumentos from "./Modais/Imports/ImportDocumentos";
import MigrarEmpresa from "./Modais/MigrarEmpresa";
import EditarObservacao from "./Modais/EditarObservacao";
import AlertModal from "./AlertModal";
import ModalUpload from "./Group/GroupDocumentos/Update";
import ModalReport from "./ModalReport";
import DataEncerramento from "./Modais/DataEncerramentoEmpresa";
import ImportacaoDocumentos from "./Modais/ImportacaoDocumentos";
import {
  FLUXO_ABERTURA_ALTERACAO_EMPRESA,
  FLUXO_ALTERACAO_ENQUADRAMENTO,
  FLUXO_BAIXA_ENCERRAMENTO_EMPRESA,
} from "./Modais/ImportacaoDocumentos/fluxosDocumentos";

import BarraAcoesOS from "./components/BarraAcoesOS";
import PainelAlertas from "./components/PainelAlertas";
import ConfirmacaoModal from "./components/ConfirmacaoModal";

import { useOrdemServico } from "./useOrdemServico";
import { useAcoesOS } from "./useAcoesOS";
import { useAvancarOS } from "./useAvancarOS";
import { consultarSituacaoFiscalApi } from "./service";
import { UploadDocumentoClientContextProps } from "../../../../../service/uploadService";
import { POST_Remove_arquivo_context } from "../../../../../service/api";
import NegociacaoOS from "./NegociacaoOS";
import { perguntarMudancaUFMunicipioEAvancar } from "./regrasAvancoOS";

export function PortalContadorOS({ numeroSolicitacao, setIsModalPortalContadorOS, isModalPortalContadorOS, idOS }) {
  const {
    dados,
    info,
    setInfo,
    objDocs,
    setObjDocs,
    docsContexto,
    filesContexto,
    loading,
    setLoading,
    estado,
    setEstado,
    reportleads,
    fetchData,
    fetchListDocumento,
    fetchListDocumentoContexto,
  } = useOrdemServico(numeroSolicitacao);

  const numeroSolicita = numeroSolicitacao;
  const clienteExists = dados?.cliente && Object.keys(dados.cliente).length > 0;

  // --- modais que ainda vivem aqui (telas de apoio, não fazem parte da
  // regra de status nem da validação de avanço) ---------------------------
  const [isModalAtribuirContador, setIsModalAtribuirContador] = useState(false);
  const [isModalAtualizarCliente, setIsModalAtualizarCliente] = useState(false);
  const [isModalNegociacaoOS, setIsModalNegociacaoOS] = useState(false);
  const [isModalGerarPix, setIsModalGerarPix] = useState(false);
  const [isModalDataEncerramento, setIsModalDataEncerramento] = useState(false);
  const [isModalDeConfirmarInicioDeNegociacaoOS, setIsModalDeConfirmarInicioDeNegociacaoOS] = useState(false);
  const [isModalDeConfirmarDesnegociacaoOS, setIsModalDeConfirmarDesnegociacaoOS] = useState(false);
  const [isModalDataMigracao, setIsModalDataMigracao] = useState(false);
  const [isModalDeConfirmarSuspensaoOS, setIsModalDeConfirmarSuspensaoOS] = useState(false);
  const [isModalDeConfirmarRestauracaoOS, setIsModalDeConfirmarRestauracaoOS] = useState(false);
  const [isModalDeConfirmarCancelarOS, setIsModalDeConfirmarCancelarOS] = useState(false);
  const [alertConfirmRetroceder, setAlertConfirmRetroceder] = useState(false);
  const [isModalCadastrarCliente, setIsModalCadastrarCliente] = useState(false);
  const [isModalEditarObservacao, setIsModalEditarObservacao] = useState(false);
  const [arrow] = useState("Show");
  const [isModalConfirmeProcess, setIsModalConfirmeProcess] = useState(false);
  const [isMostrarBtnConfirmacaoDeCasoSevero, setIsMostrarBtnConfirmacaoDeCasoSevero] = useState(false);
  const [determinarPrazo, setDeterminarPrazo] = useState(null);
  const [selectMotivo, setSelectMotivo] = useState(null);
  const [modoCadastro, setModoCadastro] = useState("");
  const [importarDocumentosDaOS, setImportarDocumentosDaOS] = useState(false);
  const [isModalImportsAberturaAlteracaoEmpresa, setisModalImportsAberturaAlteracaoEmpresa] = useState(false);
  const [isModalImportAlteracaoEnquadramento, setIsModalImportAlteracaoEnquadramento] = useState(false);
  const [isModalImportBaixaEncerramentoEmpresa, setIsModalImportBaixaEncerramentoEmpresa] = useState(false);
  const [selectedOption, setSelectedOption] = useState("ordemServico");
  const [loadingImageProcess, setLoadingImageProcess] = useState(false);
  const [isModalReportLeads, setIsModalReportLeads] = useState(false);
  const [isModalCriarClienteAtribuirAnalista, setIsModalCriarClienteAtribuirAnalista] = useState(false);
  const [current, setCurrent] = useState(0);
  const [opcaoDadosEmpresa, setOpcaoDadosEmpresa] = useState("empresa");
  const [modalUploadDoc, setModalUploadDoc] = useState(false);
  const [nomeArquivoPadrao, setNomeArquivoPadrao] = useState("");
  const [fileToRemove, setFileToRemove] = useState(null);
  const [detailsSituacaoFiscal, setDetailsSituacaoFiscal] = useState(false);
  const [base64, setBase64] = useState(null);
  const [isLoadingSituacaoFiscal, setIsLoadingSituacaoFiscal] = useState(false);

  // --- Alteração (tipo 4) com mudança de UF/Município — ver
  // verificarAnaliseJuntaComercialAlteracao e verificarDocumentosCCM em
  // regrasAvancoOS.jsx. `mudancaUF`/`mudancaMunicipio` começam em `null`
  // (pergunta ainda não respondida). `enderecoAntesDaMudancaUF`/
  // `imAntesDaMudanca` guardam um RETRATO do endereço/IM no momento em que
  // a exigência aparece (também `null` até lá) — o avanço só é liberado
  // quando o valor atual for diferente desse retrato, ou seja, quando o
  // usuário realmente editar algo (não só fechar o modal). Nada disso
  // persiste se a página recarregar — vive só enquanto esta tela estiver
  // aberta.
  const [mudancaUF, setMudancaUF] = useState(null);
  const [mudancaMunicipio, setMudancaMunicipio] = useState(null);
  const [enderecoAntesDaMudancaUF, setEnderecoAntesDaMudancaUF] = useState(null);
  const [imAntesDaMudanca, setImAntesDaMudanca] = useState(null);
  const [passouPorAJCM, setPassouPorAJCM] = useState(false);

  const [naoPossuiConselho, setNaoPossuiConselho] = useState(false);

  // Reseta as respostas de UF/Município (e os retratos de endereço/IM)
  // sempre que a OS trocar — sem isso, se este componente não desmontar
  // de verdade ao mudar de `numeroSolicitacao` (só atualizar a prop), a
  // resposta dada numa ordem "vazaria" pra próxima que for aberta.
  useEffect(() => {
    setMudancaUF(null);
    setMudancaMunicipio(null);
    setEnderecoAntesDaMudancaUF(null);
    setImAntesDaMudanca(null);
    setPassouPorAJCM(false);

    setNaoPossuiConselho(false); // adicionado
  }, [numeroSolicitacao]);


const jaHidratouMudancaUF = useRef(false);

useEffect(() => {
  jaHidratouMudancaUF.current = false; // permite hidratar de novo na próxima OS
}, [numeroSolicitacao]);

useEffect(() => {
  if (jaHidratouMudancaUF.current) return; // já rodou pra essa OS, não roda de novo
  if (mudancaUF !== null) return;
  if (dados?.tipo?.id !== "4") return;
  if (!Array.isArray(docsContexto) || docsContexto.length === 0) return;

  const temDestinoOuOrigem = docsContexto.some((arquivo) => {
    const nome = arquivo.nome?.toLowerCase() || "";
    return (
      nome.includes("constituicao-contrato-social-destino") ||
      nome.includes("constituicao-contrato-social-origem")
    );
  });

  if (temDestinoOuOrigem) {
    setMudancaUF(true);
    jaHidratouMudancaUF.current = true;
    return;
  }

  const temConstituicaoPlano = docsContexto.some((arquivo) => {
    const nome = arquivo.nome?.toLowerCase() || "";
    return (
      nome.includes("constituicao-contrato-social") &&
      !nome.includes("constituicao-contrato-social-destino") &&
      !nome.includes("constituicao-contrato-social-origem")
    );
  });

  if (temConstituicaoPlano) {
    setMudancaUF(false);
    jaHidratouMudancaUF.current = true;
    return;
  }

  // Nenhum dos 3 encontrado ainda — não marca como hidratado, porque
  // pode ser só o primeiro render antes do fetchData inicial completar.
  // Só marca hidratado quando encontrar algo, ou fica tentando até achar
  // (inofensivo: enquanto mudancaUF continuar null, a pergunta funciona
  // normalmente de qualquer forma).
}, [docsContexto, dados?.tipo?.id, mudancaUF]);

  // Marca que esta OS já passou por "Análise Junta Comercial" (A-JCM)
  // nesta sessão. Usado em verificarAnaliseJuntaComercialAlteracao pra
  // distinguir "acabou de responder a pergunta de UF, ainda não subiu
  // nada" (passouPorAJCM ainda false) de "retrocedeu depois de já ter
  // passado por A-JCM e apagou os documentos" (passouPorAJCM true) — só
  // no segundo caso a pergunta deve voltar a aparecer.
  useEffect(() => {
    const situacoesDepoisDeAJCM = ["E-CCM", "A-CCM", "C-CCM", "E-DOC", "F-DOC", "E-ENF", "F"];
    if (situacoesDepoisDeAJCM.includes(dados?.situacao?.id)) {
      setPassouPorAJCM(true);
    }
  }, [dados?.situacao?.id]);

  const cadastrarClienteRef = useRef(null);
  const atribuirAnalistaRef = useRef(null);

  useEffect(() => {
    const height = document.documentElement.scrollHeight;
    window.parent.postMessage({ frameHeight: height }, "*");
  }, []);


  // Detecta reentrada na situação V-CCM (ex.: usuário retrocedeu a OS até
// "Viabilidade da prefeitura", que é a mesma situação V-CCM, uma etapa
// antes do conselho de classe) e reseta as respostas locais dessa etapa.
// Sem isso, mudancaUF/mudancaMunicipio/naoPossuiConselho ficam com o
// valor da passagem anterior e travam o fluxo em loop, porque
// verificarMudancaUFMunicipioVCCM não pergunta de novo (mudancaUF !== null)
// mas a pergunta de conselho pode ter sido "reaberta" sem sincronismo com
// eles.
const situacaoAnteriorRef = useRef(null);

useEffect(() => {
  const situacaoAtual = dados?.situacao?.id;
  if (!situacaoAtual) return;

  if (situacaoAtual === "V-CCM" && situacaoAnteriorRef.current !== "V-CCM") {
    setNaoPossuiConselho(false);
    setMudancaUF(null);
    setMudancaMunicipio(null);
    setEnderecoAntesDaMudancaUF(null);
    setImAntesDaMudanca(null);
    jaHidratouMudancaUF.current = false; // permite rehidratar pelos documentos, se houver
  }

  situacaoAnteriorRef.current = situacaoAtual;
}, [dados?.situacao?.id]);

  const mergedArrow = useMemo(() => {
    if (arrow === "Hide") return false;
    if (arrow === "Show") return true;
    return { pointAtCenter: true };
  }, [arrow]);

  const styledBtn = `btnOS ${window.location.hash.startsWith("#/DetalheOS") ? "btn-bg-color-chat" : "bg-color-white"}`;
  const styledBtnImport = `btnOS ${window.location.hash.startsWith("#/DetalheOS") ? "btn-bg-color-chat" : "btnOS-imports"}`;

  const acoes = useAcoesOS({ numeroSolicitacao, info, fetchData, setLoading, setEstado });

  const avancarOSCtx = useAvancarOS({
    dados: dados || {},
    docsContexto,
    objDocs,
    numeroSolicitacao,
    clienteExists,
    fetchData,
    avancarDireto: acoes.avancarDireto,
    setLoading,
    setLoadingImageProcess,
    setIsModalImportsAberturaAlteracaoEmpresa: setisModalImportsAberturaAlteracaoEmpresa,
    setIsModalImportAlteracaoEnquadramento,
    setIsModalImportBaixaEncerramentoEmpresa,
    setModalUploadDoc,
    setNomeArquivoPadrao,
    setFileToRemove,
    setIsMostrarBtnConfirmacaoDeCasoSevero,
    setIsModalDataEncerramento,
    setIsModalAtualizarCliente,
    setOpcaoDadosEmpresa,
    setModoCadastro,
    setIsModalCadastrarCliente,
    setIsModalAtribuirContador,
    setIsModalDataMigracao,
    mudancaUF,
    setMudancaUF,
    mudancaMunicipio,
    setMudancaMunicipio,
    enderecoAntesDaMudancaUF,
    setEnderecoAntesDaMudancaUF,
    imAntesDaMudanca,
    setImAntesDaMudanca,
    passouPorAJCM,


    naoPossuiConselho,
  setNaoPossuiConselho,
  });
  const { avancarOS, alertConfig, setAlertConfig, alertConfirmAvancar, setAlertConfirmAvancar } = avancarOSCtx;

  const importsBloqueados = isModalImportsAberturaAlteracaoEmpresa || isModalImportAlteracaoEnquadramento || isModalImportBaixaEncerramentoEmpresa;

  const uploadPropsDocumento = {
    ...UploadDocumentoClientContextProps({}, "/upload", fetchData),
    beforeUpload: (file) => {
      const extensao = file.name.substring(file.name.lastIndexOf("."));
      return new File([file], `${nomeArquivoPadrao}${extensao}`, { type: file.type });
    },
    onChange: async (uploadInfo) => {
      if (uploadInfo.file.status !== "done") return;
      try {
        await fetchData();

        if (uploadInfo.file.name.toLowerCase().includes("formulario-codigo-municipal")) {
          await acoes.avancarDireto();
          setModalUploadDoc(false);
        }

        if (dados?.situacao?.id === "E-JCM" && ["3", "4"].includes(dados?.tipo?.id) && fileToRemove) {
          const formData = new FormData();
          formData.append("filename", fileToRemove);
          await POST_Remove_arquivo_context(`/cliente/arquivo/remover?filename=${encodeURIComponent(fileToRemove)}`, formData);
          toast.success("Arquivo Abertura-empresa excluído com sucesso!");
          await fetchData();
        }
      } catch (error) {
        toast.error("Erro no upload/exclusão de arquivo.");
      } finally {
        setModalUploadDoc(false);
      }
    },
  };

  const completarOSLink = () => {
    const url = `/vendas/#Wizard01/REVERSAO-${info.usuarioAlteracao}/${numeroSolicita}`;
    window.open(url, "_blank");
  };

  const consultarSituacaoFiscal = async (idCliente, cnpjEmpresa) => {
    if (isLoadingSituacaoFiscal) return;
    setBase64(null);
    setDetailsSituacaoFiscal(true);
    setIsLoadingSituacaoFiscal(true);
    try {
      const result = await consultarSituacaoFiscalApi(idCliente, cnpjEmpresa);
      setBase64(result.base64);
    } finally {
      setIsLoadingSituacaoFiscal(false);
    }
  };
  

  const handleNext = async () => {
    if (current === 0 && cadastrarClienteRef.current) {
      const ok = await cadastrarClienteRef.current.cadastrarOuTrocar();
      if (!ok) return;
    }
    setCurrent(current + 1);
  };

  const handleFinalizar = async () => {
    if (!atribuirAnalistaRef.current) return;
    const ok = await atribuirAnalistaRef.current.atribuirAnalista();
    if (ok) {
      setIsModalCriarClienteAtribuirAnalista(false);
      setTimeout(() => avancarOS(), 2000);
    }
  };

  const steps = [
    {
      title: "Cadastrar Cliente",
      content: (
        <CadastrarCliente
          ref={cadastrarClienteRef}
          info={info}
          setInfo={setInfo}
          fecharModalCadastrarCliente={() => {
            setIsModalCadastrarCliente(false);
            setModoCadastro("");
          }}
          setIsModalCadastrarCliente={setIsModalCadastrarCliente}
          numeroSolicita={numeroSolicita}
          avancarOS={avancarOS}
          fetchData={fetchData}
          clienteExists={clienteExists}
          visibleBtn={isModalCriarClienteAtribuirAnalista}
        />
      ),
    },
    {
      title: "Atribuir Analista",
      content: (
        <AtribuirAnalista
          ref={atribuirAnalistaRef}
          info={info}
          setInfo={setInfo}
          setIsModalAtribuirContador={setIsModalAtribuirContador}
          numeroSolicita={numeroSolicita}
          fetchData={fetchData}
          visibleBtn={isModalCriarClienteAtribuirAnalista}
        />
      ),
    },
  ];

  if (loading) {
    return (
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "300px" }}>
        <Spin indicator={<LoadingOutlined spin />} size="large" />
      </div>
    );
  }

  const botoes = estado.botoes;

  return (
    <>
      <ModalContainer>
        <div className="main">
          <BarraAcoesOS
            botoes={botoes}
            loading={loading}
            info={info}
            reportleads={reportleads}
            mergedArrow={mergedArrow}
            styledBtn={styledBtn}
            styledBtnImport={styledBtnImport}
            mostrarBotaoVoltar={!window.location.hash.startsWith("#/DetalheOS")}
            onVoltar={() => setIsModalPortalContadorOS(false)}
            onReportarLeads={() => setIsModalReportLeads(true)}
            onAvancarPerfilVendas={() => setIsModalCriarClienteAtribuirAnalista(true)}
            onNegociar={() => setIsModalNegociacaoOS(true)}
            onIniciarNegociacao={() => setIsModalDeConfirmarInicioDeNegociacaoOS(true)}
            onRetroceder={() => setAlertConfirmRetroceder(true)}
            onAvancar={() => setAlertConfirmAvancar(true)}
            onDesnegociar={() => setIsModalDeConfirmarDesnegociacaoOS(true)}
            onEditarObservacao={() => setIsModalEditarObservacao(true)}
            onAtribuirAnalista={() => setIsModalAtribuirContador(true)}
            onTrocarCliente={() => {
              setModoCadastro("optionTrocarCliente");       
              setIsModalCadastrarCliente(true);
            }}
            onAtualizarCliente={() => setIsModalAtualizarCliente(true)}
            onDataMigracao={() => setIsModalDataMigracao(true)}
            onDataEncerramento={() => setIsModalDataEncerramento(true)}
            onGerarBoleto={acoes.gerarBoleto}
            loadingGerarBoleto={acoes.loadingGerarBoleto}
            onGerarPix={async () => {
              const ok = await acoes.gerarPix();
              if (ok) setIsModalGerarPix(true);
            }}
            loadingGerarPix={acoes.loadingGerarPix}
            onCompletarOS={completarOSLink}
            onCarregarDocumento={() => setImportarDocumentosDaOS(true)}
            onImportAberturaAlteracao={() => setisModalImportsAberturaAlteracaoEmpresa(true)}
            onImportEnquadramento={() => setIsModalImportAlteracaoEnquadramento(true)}
            onImportBaixaEncerramento={() => setIsModalImportBaixaEncerramentoEmpresa(true)}
            importsBloqueados={importsBloqueados}
            onCancelar={() => setIsModalDeConfirmarCancelarOS(true)}
            onRestaurar={() => setIsModalDeConfirmarRestauracaoOS(true)}
            onSuspender={() => setIsModalDeConfirmarSuspensaoOS(true)}
          />

          <div style={{ width: "94%", margin: "0 auto" }}>
            <div className="modalOS">
              <div className="padding10 styled-label text-align">
                <label>
                  {info.tipo} {info.fgExecucaoSuspensa === true && <strong style={{ color: "#ffa700" }}> SUSPENSA</strong>}
                </label>
              </div>

              <div className="padding10">
                {loadingImageProcess ? (
                  <div className="justifyContent">
                    <div className="containt-modal">
                      {Array.from({ length: 14 }).map((_, index) => (
                        <div key={index} style={{ margin: "5px" }}>
                          <SkeletonCircle>
                            <ShimmerEffect />
                          </SkeletonCircle>
                        </div>
                      ))}
                    </div>
                  </div>
                ) : (
                  <Processos situacaoId={info.situacaoId} tipoId={info.tipoId} conselho={info.conselho} />
                )}
              </div>

              <PainelAlertas estado={estado} />

              <div className="padding10 margin-auto" style={{ textAlign: "center" }}>
                <Flex vertical gap="middle">
                  <Radio.Group
                    value={selectedOption}
                    onChange={(e) => setSelectedOption(e.target.value)}
                    className={styles.segmented}
                  >
                    {/**<Radio.Button value="inicio">Triagem</Radio.Button> */}
                    <Radio.Button value="ordemServico">Ordem de Serviço</Radio.Button>
                    <Radio.Button value="contato">Contato</Radio.Button>
                    {estado.showEmpresa && <Radio.Button value="empresa">Empresa</Radio.Button>}
                    {estado.showQuadroSocioAdministrativoRadio && (
                      <Radio.Button value="quadroSocioAdministrativo">Quadro Sócio Administrativo</Radio.Button>
                    )}
                    {estado.showAcessos && <Radio.Button value="acessos">Acessos</Radio.Button>}
                    {estado.showFaturamento && <Radio.Button value="faturamento">Faturamento</Radio.Button>}
                    <Radio.Button value="documentos">Documentos</Radio.Button>
                    <Radio.Button value="historico">Histórico</Radio.Button>
                  </Radio.Group>
                </Flex>
              </div>

              <br />

              <div className="width-margin">
                {selectedOption === "inicio" && (
                  <GroupInicio info={info} setInfo={setInfo} setIsModalAtualizarCliente={setIsModalAtualizarCliente} />
                )}
                {selectedOption === "ordemServico" && (
                  <GroupOrdemServico
                    info={info}
                    setInfo={setInfo}
                    fetchData={fetchData}
                    numeroSolicitacao={numeroSolicitacao}
                    setIsModalEditarObservacao={setIsModalEditarObservacao}
                  />
                )}
                {selectedOption === "contato" && <GroupContato info={info} setInfo={setInfo} />}
                {selectedOption === "empresa" && (
                  <GroupEmpresa info={info} setInfo={setInfo} consultarSituacaoFiscal={consultarSituacaoFiscal} />
                )}
                {selectedOption === "quadroSocioAdministrativo" && <GroupQuadroSocioAdministrativo info={info} />}
                {selectedOption === "acessos" && <GroupAcessos info={info} setInfo={setInfo} />}
                {selectedOption === "faturamento" && <GroupFaturamento info={info} setInfo={setInfo} />}
                {selectedOption === "documentos" && (
                  <GroupDocumentos
                    dados={dados}
                    info={info}
                    setInfo={setInfo}
                    numeroSolicitacao={numeroSolicitacao}
                    fetchData={fetchData}
                    loading={loading}
                    fetchListDocumento={fetchListDocumento}
                    setObjDocs={setObjDocs}
                    objDocs={objDocs}
                    docsContexto={docsContexto}
                    filesContexto={filesContexto}
                    fetchListDocumentoContexto={fetchListDocumentoContexto}


                    setMudancaUF={setMudancaUF}
  setMudancaMunicipio={setMudancaMunicipio}
  setEnderecoAntesDaMudancaUF={setEnderecoAntesDaMudancaUF}
  setImAntesDaMudanca={setImAntesDaMudanca}
                  />
                )}
                {selectedOption === "historico" && <GroupHistorico info={info} setInfo={setInfo} numeroSolicitacao={numeroSolicitacao} />}
              </div>

              {!window.location.hash.startsWith("#/DetalheOS") && (
                <div style={{ padding: 10 }}>
                  <div style={{ textAlign: "right" }}>
                    <Button onClick={() => setIsModalPortalContadorOS(false)}>Fechar</Button>
                  </div>
                </div>
              )}
            </div>
          </div>

          <Modal title="Pix gerado" open={isModalGerarPix} onCancel={() => setIsModalGerarPix(false)} footer={null}>
            <GerarPix
              pixBase64={acoes.pixBase64}
              qrCode={acoes.qrCode}
              setQrCode={acoes.setQrCode}
              valor={acoes.valor}
              setIsModalGerarPix={setIsModalGerarPix}
            />
          </Modal>

          <Modal open={isModalAtribuirContador} title="Atribuir Analista Contador" onCancel={() => setIsModalAtribuirContador(false)} footer={null}>
            <div style={{ marginBottom: 10 }}>
              <Alert description="Atribua o analista de contabilidade que irá dar andamento e tratar esta ordem de serviço." type="info" showIcon />
            </div>
            <div className="instructions">
              <Alert message="Atenção" description="É necessário atribuir um analista para prosseguir." type="warning" showIcon />
              <br />
            </div>
            <AtribuirAnalista info={info} setInfo={setInfo} setIsModalAtribuirContador={setIsModalAtribuirContador} numeroSolicita={numeroSolicita} fetchData={fetchData} />
          </Modal>

          {isModalAtualizarCliente && (
            <AtualizarCliente
              info={info}
              setInfo={setInfo}
              numeroSolicitacao={numeroSolicitacao}
              fetchData={fetchData}
              setIsModalAtualizarCliente={setIsModalAtualizarCliente}
              isModalAtualizarCliente={isModalAtualizarCliente}
              setisModalImportsAberturaAlteracaoEmpresa={setisModalImportsAberturaAlteracaoEmpresa}
              setModalUploadDoc={setModalUploadDoc}
              opcaoDadosEmpresa={opcaoDadosEmpresa}
            />
          )}

          <Modal open={isModalNegociacaoOS} title="Negociar OS" footer={null} onCancel={() => setIsModalNegociacaoOS(false)} width="40%">
            <NegociacaoOS info={info} setInfo={setInfo} setIsModalNegociacaoOS={setIsModalNegociacaoOS} numeroSolicitacao={numeroSolicitacao} fetchData={fetchData} />
          </Modal>

          <Modal open={isModalDataEncerramento} title="Data de encerramento da Empresa" onCancel={() => setIsModalDataEncerramento(false)} footer={null}>
            <DataEncerramento setIsModalDataEncerramento={setIsModalDataEncerramento} info={info} setInfo={setInfo} fetchData={fetchData} numeroSolicita={numeroSolicita} />
          </Modal>

          <ConfirmacaoModal
            open={isModalDeConfirmarInicioDeNegociacaoOS}
            mensagem={<p>Confirma marcar a Ordem de Serviço <strong>{numeroSolicita}</strong> em negociação?</p>}
            onConfirm={() => acoes.iniciarNegociacao(estado.situacaoInicialParaNegociacao).then(() => setIsModalDeConfirmarInicioDeNegociacaoOS(false))}
            onCancel={() => setIsModalDeConfirmarInicioDeNegociacaoOS(false)}
          />

          <ConfirmacaoModal
            open={isModalDeConfirmarDesnegociacaoOS}
            mensagem={<p>Confirma desmarcar a Ordem de Serviço <strong>{numeroSolicita}</strong> em negociação?</p>}
            onConfirm={() => acoes.desfazerNegociacao().then(() => setIsModalDeConfirmarDesnegociacaoOS(false))}
            onCancel={() => setIsModalDeConfirmarDesnegociacaoOS(false)}
          />

          <ConfirmacaoModal
            open={isModalDeConfirmarSuspensaoOS}
            mensagem={<p>Confirma a suspensão da Ordem de Serviço <strong>{numeroSolicita}</strong>?</p>}
            onConfirm={() => acoes.suspender().then(() => setIsModalDeConfirmarSuspensaoOS(false))}
            onCancel={() => setIsModalDeConfirmarSuspensaoOS(false)}
            loading={loading}
          />

          <ConfirmacaoModal
            open={isModalDeConfirmarRestauracaoOS}
            mensagem={<p>Confirma a restauração da Ordem de Serviço <strong>{numeroSolicita}</strong>?</p>}
            onConfirm={() => acoes.restaurar().then(() => setIsModalDeConfirmarRestauracaoOS(false))}
            onCancel={() => setIsModalDeConfirmarRestauracaoOS(false)}
            loading={loading}
          />

          <ConfirmacaoModal
            open={isModalDeConfirmarCancelarOS}
            mensagem={<p>Confirma o cancelamento da Ordem de Serviço <strong>{numeroSolicita}</strong>?</p>}
            onConfirm={() => acoes.cancelar().then(() => setIsModalDeConfirmarCancelarOS(false))}
            onCancel={() => setIsModalDeConfirmarCancelarOS(false)}
            loading={loading}
          />

          <Modal
            title={modoCadastro === "optionCadastrarCliente" ? "Cadastrar Cliente" : "Trocar Cliente"}
            open={isModalCadastrarCliente}
            footer={null}
            onCancel={() => setIsModalCadastrarCliente(false)}
            width="50%"
          >
            <Alert message="Atenção" description="É necessário cadastrar o cliente para prosseguir." type="warning" showIcon />
            <CadastrarCliente
              info={info}
              setInfo={setInfo}
              fecharModalCadastrarCliente={() => {
                setIsModalCadastrarCliente(false);
                setModoCadastro("");
              }}
              setIsModalCadastrarCliente={setIsModalCadastrarCliente}
              numeroSolicita={numeroSolicita}
              modo={modoCadastro}
              avancarOS={avancarOS}
              fetchData={fetchData}
              clienteExists={clienteExists}
            />
          </Modal>

          <Modal open={isModalDataMigracao} title="Migração de Empresa" onCancel={() => setIsModalDataMigracao(false)} footer={null}>
            <MigrarEmpresa info={info} dados={dados} numeroSolicitacao={numeroSolicitacao} setIsModalDataMigracao={setIsModalDataMigracao} fetchData={fetchData} />
          </Modal>

          <Modal open={alertConfirmAvancar} title="Confirmação" onOk={avancarOS} onCancel={() => setAlertConfirmAvancar(false)} okText="Sim" cancelText="Não">
            <p>Confirma o avanço da Ordem de Serviço [<strong>{numeroSolicita}</strong>]?</p>
          </Modal>

          <ConfirmacaoModal
            open={alertConfirmRetroceder}
            mensagem={<p>Confirma o retrocesso da Ordem de Serviço [<strong>{numeroSolicita}</strong>]?</p>}
            onConfirm={() => acoes.retroceder().then(() => setAlertConfirmRetroceder(false))}
            onCancel={() => setAlertConfirmRetroceder(false)}
          />

          <Modal
            open={importarDocumentosDaOS}
            title="Carregar arquivos"
            onCancel={() => setImportarDocumentosDaOS(false)}
            footer={<Button onClick={() => setImportarDocumentosDaOS(false)}>Fechar</Button>}
          >
            <ImportDocumentos numeroSolicitacao={numeroSolicitacao} fetchListDocumento={fetchListDocumento} setImportarDocumentosDaOS={setImportarDocumentosDaOS} fetchListDocumentoContexto={fetchListDocumentoContexto} />
          </Modal>

          <Modal open={isModalEditarObservacao} title="Editar observação" onCancel={() => setIsModalEditarObservacao(false)} footer={null}>
            <EditarObservacao info={info} setInfo={setInfo} fetchData={fetchData} numeroSolicitacao={numeroSolicitacao} setIsModalEditarObservacao={setIsModalEditarObservacao} />
          </Modal>

          {isModalImportsAberturaAlteracaoEmpresa && (
            <ImportacaoDocumentos
              fluxo={FLUXO_ABERTURA_ALTERACAO_EMPRESA}
              open={isModalImportsAberturaAlteracaoEmpresa}
              onClose={setisModalImportsAberturaAlteracaoEmpresa}
              numeroSolicitacao={numeroSolicitacao}
              fetchData={fetchData}
              setModalUploadDoc={setModalUploadDoc}
              fetchListDocumento={fetchListDocumento}
              setObjDocs={setObjDocs}
              objDocs={objDocs}
              forcarExigenciaIE={nomeArquivoPadrao === "Inscricao-estadual"}
              dados={dados || {}}
            />
          )}

          {isModalImportAlteracaoEnquadramento && (
            <ImportacaoDocumentos
              fluxo={FLUXO_ALTERACAO_ENQUADRAMENTO}
              open={isModalImportAlteracaoEnquadramento}
              onClose={setIsModalImportAlteracaoEnquadramento}
              numeroSolicitacao={numeroSolicitacao}
              fetchData={fetchData}
              setModalUploadDoc={setModalUploadDoc}
              fetchListDocumento={fetchListDocumento}
              setObjDocs={setObjDocs}
              objDocs={objDocs}
              forcarExigenciaIE={nomeArquivoPadrao === "Inscricao-estadual"}
              dados={dados || {}}
            />
          )}

          {isModalImportBaixaEncerramentoEmpresa && (
            <ImportacaoDocumentos
              fluxo={FLUXO_BAIXA_ENCERRAMENTO_EMPRESA}
              open={isModalImportBaixaEncerramentoEmpresa}
              onClose={setIsModalImportBaixaEncerramentoEmpresa}
              numeroSolicitacao={numeroSolicitacao}
              fetchData={fetchData}
              setModalUploadDoc={setModalUploadDoc}
              fetchListDocumento={fetchListDocumento}
              setObjDocs={setObjDocs}
              objDocs={objDocs}
              forcarExigenciaIE={nomeArquivoPadrao === "Inscricao-estadual"}
              dados={dados || {}}
            />
          )}

<Modal
  open={isMostrarBtnConfirmacaoDeCasoSevero}
  title="Confirmação"
  closable={false}
  maskClosable={false}
  onOk={() => {
    setIsMostrarBtnConfirmacaoDeCasoSevero(false);
    setIsModalConfirmeProcess(true);
  }}
  onCancel={() => {
    setNaoPossuiConselho(true); // grava a resposta "Não"
    setIsMostrarBtnConfirmacaoDeCasoSevero(false);

    if (dados?.situacao?.id === "V-CCM" && ["3", "4"].includes(dados.tipo?.id) && mudancaUF === null) {
      // Tipo 4 tem o fluxo de UF/Município logo em seguida.
      perguntarMudancaUFMunicipioEAvancar({
        setAlertConfirmAvancar,
        setMudancaUF,
        setMudancaMunicipio,
        avancarDireto: acoes.avancarDireto,
      });
    } else if (dados?.situacao?.id === "V-CCM") {
      // Demais tipos (1, 5) não têm pergunta extra nesta etapa —
      // respondida a questão do conselho, já avança direto.
      acoes.avancarDireto();
    }
  }}
  okText="Sim"
  cancelText="Não"
>
  <p>Possui conselho de classe?</p>
</Modal>

          <Modal title="Confirmação" open={isModalConfirmeProcess} onCancel={() => setIsModalConfirmeProcess(false)} footer={null}>
            <div className="container">
              {acoes.loadingConselho ? (
                <div className="margin-0-auto">
                  <Box sx={{ display: "flex" }}>
                    <CircularProgress />
                  </Box>
                </div>
              ) : (
                <div className="padding-5">
                  <div style={{ display: "flex" }}>
                    <div style={{ margin: 5 }}>
                      <p>Determine o prazo</p>
                      <Input placeholder="Prazo em Dias" onChange={(e) => setDeterminarPrazo(e.target.value)} value={determinarPrazo} style={{ width: 120 }} />
                    </div>
                    <div style={{ margin: 5 }}>
                      <p>Motivo</p>
                      <Select
                        placeholder="Selecione o motivo"
                        value={selectMotivo}
                        onChange={(e) => setSelectMotivo(e)}
                        defaultValue=""
                        style={{ width: 331 }}
                        options={[
                          { value: "", label: "Selecione o motivo", disabled: true },
                          { value: "Conselho de Classe", label: "Conselho de Classe" },
                          { value: "Dois órgãos de Registro", label: "Dois órgãos de Registro" },
                          { value: "Empresa Estabelecida (com alvará)", label: "Empresa Estabelecida (com alvará)" },
                          { value: "Registro OAB/Cartório", label: "Registro OAB/Cartório" },
                          { value: "Sócio Falecido", label: "Sócio Falecido" },
                          { value: "Prefeitura com análise demorada", label: "Prefeitura com análise demorada" },
                        ]}
                      />
                    </div>
                  </div>
                  <div style={{ textAlign: "right", margin: 5 }}>
                    <Button
  type="primary"
  className="color"
  onClick={() =>
    acoes.confirmarConselho(determinarPrazo, selectMotivo).then((ok) => {
      if (!ok) return;
      setIsModalConfirmeProcess(false);

      // Assim como no caminho "Não possui conselho", tipo 4 tem o fluxo
      // de UF/Município em seguida — pergunta já na sequência, sem
      // esperar um novo clique em "Avançar".
      if (dados?.situacao?.id === "V-CCM" && ["3", "4"].includes(dados.tipo?.id) && mudancaUF === null) {
        perguntarMudancaUFMunicipioEAvancar({
          setAlertConfirmAvancar,
          setMudancaUF,
          setMudancaMunicipio,
          avancarDireto: acoes.avancarDireto,
        });
      }
      else if (dados?.situacao?.id === "V-CCM") {
      // Demais tipos (1, 3, 5) não têm pergunta extra nesta etapa —
      // respondida a questão do conselho, já avança direto.
      acoes.avancarDireto();
    }
    })
  }
  disabled={acoes.loadingConselho}
  loading={acoes.loadingConselho}
>
  Confirmar
</Button>
                  </div>
                </div>
              )}
            </div>
          </Modal>
        </div>

        <AlertModal
          open={alertConfig.open}
          title={alertConfig.title}
          message={alertConfig.message}
          onClose={() => {
            setAlertConfig({ ...alertConfig, open: false });
            alertConfig.onClose?.();
          }}
        />
      </ModalContainer>

      <Modal title="Carregar documento" open={modalUploadDoc} zIndex={2000} onCancel={() => setModalUploadDoc(false)} footer={<Button onClick={() => setModalUploadDoc(false)}>Fechar</Button>}>
        <ModalUpload onclose={() => setModalUploadDoc(false)} uploadProps={uploadPropsDocumento} />
      </Modal>

      <Modal
        title="Situação Fiscal"
        open={detailsSituacaoFiscal}
        width="75%"
        onCancel={() => {
          setDetailsSituacaoFiscal(false);
          setBase64(null);
        }}
        footer={null}
      >
        {isLoadingSituacaoFiscal ? (
          <div style={{ textAlign: "center" }}>
            <Spin indicator={<LoadingOutlined spin />} size="large" />
          </div>
        ) : (
          <iframe src={`data:application/pdf;base64,${base64}`} title="PDF Viewer" width="100%" height="600px" />
        )}
      </Modal>

      <Modal title="Reportar Leads" open={isModalReportLeads} onCancel={() => setIsModalReportLeads(false)} footer={null}>
        <ModalReport info={info} setIsModalReportLeads={setIsModalReportLeads} atualizarOS={fetchData} />
      </Modal>

      <Modal title="Criar cliente e atribuir analista para a OS" open={isModalCriarClienteAtribuirAnalista} onCancel={() => setIsModalCriarClienteAtribuirAnalista(false)} width="55%" footer={null}>
        <div className="mb-4">
          <Alert
            message="Atribua o analista de contabilidade que irá dar andamento e tratar esta ordem de serviço."
            description="É necessário atribuir um analista e cadastrar o cliente para prosseguir."
            type="warning"
            showIcon
          />
        </div>
        <div style={{ padding: 10 }}>
          <Steps current={current} items={steps.map((s) => ({ title: s.title }))} />
        </div>
        <div className="my-6">{steps[current].content}</div>
        <div style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}>
          {current > 0 && <Button onClick={() => setCurrent(current - 1)}>Voltar</Button>}
          {current < steps.length - 1 && (
            <Button type="primary" onClick={handleNext}>
              Avançar
            </Button>
          )}
          {current === steps.length - 1 && (
            <Button type="primary" onClick={handleFinalizar}>
              Finalizar
            </Button>
          )}
        </div>
      </Modal>
    </>
  );
}

export default PortalContadorOS;
